module.exports = __webpack_public_path__ + "img/type-01.82fceb6a.jpg";